import React, { useContext, useEffect, useState, useCallback } from 'react';
import QueryString from 'qs';
import {customAlphabet} from 'nanoid'
import { useOnline } from './Online';
import { useWebCfg } from './WebCfg';
import { useNavigate } from 'react-router-dom';

const nanoid = customAlphabet('1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZ', 21)
const responseType = 'code';
const scope = 'openid';

const Auth = React.createContext();

export const useAuth = () =>{
    var context = useContext(Auth);
    if(!context){
        throw new Error('components that "useNftAuth" need to be children of an <NftAuthProvider>');
    }
    return context;
}

function parseJwt (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

function getExpiresAtSeconds(expires_in){
    const curSec = Math.floor(Date.now()/1000);
    var ret = curSec + parseInt(expires_in);
    return ret;
}

function getExpiresInSeconds(expires_at){
    const curSec = Math.floor(Date.now()/1000);
    var ret= parseInt(expires_at?expires_at:curSec) - curSec;
    return ret;

}

const AuthProvider = ({children}) =>{
    var online = useOnline();
    var webCfg = useWebCfg();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(true);
    const [userData, setUserData] = useState(null);
    const [WellKnown, setWellKnown] = useState(null);

    const getTokenLSName = useCallback( () => {
        return `token_${webCfg.ClientId}`
    },[webCfg.ClientId])

    const getStateLSName = useCallback( () => {
        return `state_${webCfg.ClientId}`
    },[webCfg.ClientId])
    


    async function signIn(){
        if(WellKnown){
            var nonce = nanoid();
            var state = nanoid();
            var codeVerifier = nanoid(56);
            var uri = `${WellKnown.authorization_endpoint}?client_id=${webCfg.ClientId}&response_type=${responseType}&redirect_uri=${window.location.protocol}//${window.location.host}/api/oidc_callback&nonce=${nonce}&scope=${scope}&state=${state}&prompt=select_account consent&access_type=offline`;//&code_challenge_method=${codeChallengeMethod}&code_challenge=${codeVerifier}
            uri = encodeURI(uri);
            console.log(uri)
            var stateObj = {state, codeVerifier};
            localStorage.setItem(getStateLSName(), JSON.stringify(stateObj));
            setIsLoading(true);
            window.location.replace(uri);
            setTimeout(()=>{setIsLoading(false)}, 5000);
        }
    }

    async function signOut(){
        setUserData(null);
        localStorage.removeItem(getTokenLSName());
        //console.log(WellKnown)
        if(WellKnown && WellKnown.end_session_endpoint){
            var uri = `${WellKnown.end_session_endpoint}?client_id=${webCfg.ClientId}&logout_uri=${window.location.protocol}//${window.location.host}&response_type=${responseType}`;
            uri = encodeURI(uri);
            console.log(uri)
            setIsLoading(true);
            window.location.replace(uri);
            setTimeout(()=>{setIsLoading(false)}, 5000);
        }
    }

    const refresh = useCallback( async (user) => {
        console.log(user)
        if(!user)return;
        if(!user.refresh_token){   
            setUserData(null);
            localStorage.removeItem(getTokenLSName());
            return;
        }
        
        const uri = `api/oidc_refresh`;
        var body = {refresh_token:user.refresh_token};
        try{
            var tokenResult = await fetch(uri, {
                method:'post', 
                body: JSON.stringify(body),
                headers: new Headers({'content-type': 'application/json'})})
            var token = await tokenResult.json();
            if(token.id_token){
                token.profile = parseJwt(token.id_token);
                //(token.profile)
            }
            if(token.expires_in){
                token.expires_at = getExpiresAtSeconds(token.expires_in);
            }
            if(token && !token.error){
                if( !token.refresh_token) token.refresh_token = user.refresh_token;
                //console.log(token)
                setUserData(token);
                localStorage.setItem(getTokenLSName(), QueryString.stringify(token));
            }
            else{
                setUserData(null);
                localStorage.removeItem(getTokenLSName());
            }
        }
        catch
        {
            setUserData(null);
            localStorage.removeItem(getTokenLSName());
        }
        return;
      },[getTokenLSName])

    useEffect(() => {
        var timer = null;
        if(online&&userData && WellKnown){
          const time = Math.max(1,(getExpiresInSeconds(userData.expires_at) - 30)*1000);
          timer = setTimeout(async ()=>{
            await refresh(userData);
          }, time);
        }
        return () => { if(timer) clearTimeout(timer);}
      }, [userData, WellKnown, online, refresh]);
    

    const loadLocal = useCallback( async() => {
        var ls = localStorage.getItem(getTokenLSName());
        if(ls){
            var lsData = QueryString.parse(ls);
            if( lsData && lsData.id_token && lsData.expires_at){
                lsData.expires_in = getExpiresInSeconds(lsData.expires_at)
                
                if(lsData.expires_in > 30)
                {
                    //console.log(lsData)
                    setUserData(lsData);
                    return;
                }
                if(lsData.refresh_token){
                    await refresh(lsData);
                    return;
                }
            }

            localStorage.removeItem(getTokenLSName());
        }
    },[setUserData, getTokenLSName, refresh])

    useEffect(()=>{
        var stilLoaded = true;
        const init = async ()=>{
            var wellKnown = null;
            while(!wellKnown){
                try {
                        
                    const uri = `api/.well-known/openid-configuration`;
                    var wellKnownResult = await fetch(uri, {
                        method:'get', 
                        headers: new Headers({'content-type': `application/json`})})
                    wellKnown = await wellKnownResult.json();
                } catch (error) {
                    await new Promise(r => setTimeout(r, 1000));   
                }
            }
            if(stilLoaded){
                setWellKnown(wellKnown);
                if(window.location.hash.length >1){
                    var hashData = QueryString.parse(window.location.hash.substring(1));
                    var stateObj = JSON.parse(localStorage.getItem(getStateLSName()));
                    localStorage.removeItem(getStateLSName());
                    window.location.hash = "";
                    if(stateObj && hashData.state === stateObj.state && !hashData.error ){
                        delete hashData.state;
                        if(hashData.id_token){
                            hashData.profile = parseJwt(hashData.id_token);
                            //console.log(hashData.profile)
                        }
                        if(hashData.expires_in){
                            hashData.expires_at = getExpiresAtSeconds(hashData.expires_in);

                        }
                        if(hashData ){
                            //console.log(hashData)
                            setUserData(hashData);
                            localStorage.setItem(getTokenLSName(), QueryString.stringify(hashData));
                        }
                    }
                    else if(!hashData.error && hashData.state && !hashData.id_token){
                        console.log(hashData)
                        navigate(hashData.state , { replace: true });
                        loadLocal();
                    }
                    else{
                        console.log(hashData)
                    }
                }
                else{
                    loadLocal();
                }

                if(stilLoaded){
                    setIsLoading(false);
                }
            }
        }
        init();
        return () => { stilLoaded = false;}
    },[setIsLoading, setWellKnown, loadLocal, getStateLSName, getTokenLSName, navigate]);
    console.log(userData)
    return (
        <Auth.Provider 
            value={{
                    isLoading, 
                    signIn,
                    signOut,
                    userData,
                    admin:userData&&userData.profile&&userData.profile['cognito:groups']&&userData.profile['cognito:groups'].includes(webCfg.AdminGroup)
            }} >
            {children}
        </Auth.Provider>
    )
}

export default AuthProvider;